import { render, staticRenderFns } from "./typeFour.vue?vue&type=template&id=4598759a&scoped=true"
import script from "./typeFour.vue?vue&type=script&lang=js"
export * from "./typeFour.vue?vue&type=script&lang=js"
import style0 from "./typeFour.vue?vue&type=style&index=0&id=4598759a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4598759a",
  null
  
)

export default component.exports